import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export function Footer() {
  const { t } = useLanguage();

  const navLinks = [
    { label: t.nav.home, href: "/#startseite", id: "footer-link-home" },
    { label: t.nav.services, href: "/#leistungen", id: "footer-link-services" },
    { label: t.nav.references, href: "/#referenzen", id: "footer-link-references" },
    { label: t.nav.about, href: "/#ueber-uns", id: "footer-link-about" },
    { label: t.nav.contact, href: "/#kontakt", id: "footer-link-contact" },
  ];

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-navy-deep">
      <div className="blueprint-grid-dark mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-20">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="grid h-8 w-8 place-items-center bg-white font-display text-sm font-bold text-navy">A</span>
              <span className="font-display text-lg font-bold tracking-tight text-white">ArStudio Elektro</span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">{t.footer.tagline}</p>
          </div>

          <div>
            <p className="mb-5 font-mono text-xs uppercase tracking-[0.25em] text-white/50">{t.footer.navTitle}</p>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} data-testid={l.id} className="text-sm text-white/70 transition-colors hover:text-white">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="mb-5 font-mono text-xs uppercase tracking-[0.25em] text-white/50">{t.footer.contactTitle}</p>
            <ul className="space-y-3 text-sm text-white/70">
              <li>
                <a href="tel:+38345813843" data-testid="footer-phone-link" className="transition-colors hover:text-white">
                  +383 45 813 843
                </a>
              </li>
              <li>
                <a href="mailto:info@ar-elektro.online" data-testid="footer-email-link" className="break-all transition-colors hover:text-white">
                  info@ar-elektro.online
                </a>
              </li>
            </ul>
            <p className="mb-3 mt-8 font-mono text-xs uppercase tracking-[0.25em] text-white/50">{t.footer.legalTitle}</p>
            <ul className="space-y-3">
              <li>
                <Link to="/impressum" data-testid="footer-link-impressum" className="text-sm text-white/70 transition-colors hover:text-white">
                  {t.footer.impressum}
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" data-testid="footer-link-datenschutz" className="text-sm text-white/70 transition-colors hover:text-white">
                  {t.footer.datenschutz}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-white/45">
            © {new Date().getFullYear()} ArStudio Elektro. {t.footer.rights}
          </p>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/35">ar-elektro.online</p>
        </div>
      </div>
    </footer>
  );
}
